import { determineIdentifierCodeType, validateBic, validateEmail, validateIban } from '../../actions/validation'

export const findPersonModalFormErrors = (t, e, formErrors, person) => {
	let checkSingle = false
	let fieldValue = null
	if (e && e.target && e.target.id) {
		checkSingle = true
		fieldValue = e.target.value
	}

	let newErrors = {}
	if (checkSingle) {
		newErrors = formErrors
	}

	if ((checkSingle && 'nr' === e.target.id) || !checkSingle) {
		const nr = checkSingle ? fieldValue : person.nr
		if (nr && nr !== '') {
			if (nr < 1) {
				newErrors.nr = t('PersonNumberIsInvalid', 'Henkilönumero ei voi olla pienempi kuin 1')
			} else if (nr.length > 19) {
				newErrors.nr = t('PersonNumberIsTooLong', 'Henkilönumero on liian pitkä')
			} else {
				delete newErrors.nr
			}
		} else {
			delete newErrors.nr
		}
	}

	if ((checkSingle && 'forename' === e.target.id) || !checkSingle) {
		const forename = checkSingle ? fieldValue : person.forename
		if (!forename || forename === '') {
			newErrors.forename = t('ForenameIsRequired', 'Etunimi on pakollinen')
		} else {
			delete newErrors.forename
		}
	}

	if ((checkSingle && 'surname' === e.target.id) || !checkSingle) {
		const surname = checkSingle ? fieldValue : person.surname
		if (!surname || surname === '') {
			newErrors.surname = t('SurnameIsRequired', 'Sukunimi on pakollinen')
		} else {
			delete newErrors.surname
		}
	}

	if ((checkSingle && 'socSec' === e.target.id) || !checkSingle) {
		const socSec = checkSingle ? fieldValue : person.socSec
		const identifierCodeType = determineIdentifierCodeType(socSec)
		if (identifierCodeType !== undefined && !identifierCodeType) {
			// undefined is empty identifier (valid), false means invalid
			newErrors.socSec = t('SocSecIsInvalid', 'Yksilöintitunnus on virheellinen')
		} else {
			delete newErrors.socSec
		}
	}

	if ((checkSingle && 'iban' === e.target.id) || !checkSingle) {
		const iban = checkSingle ? fieldValue : (person.iban ?? person.details?.iban)
		if (!validateIban(iban)) {
			newErrors.iban = t('BankAccountIsInvalid', 'Tilinumero on virheellinen')
		} else {
			delete newErrors.iban
			delete newErrors.bic
		}
	}

	if ((checkSingle && 'bic' === e.target.id) || !checkSingle) {
		const bic = checkSingle ? fieldValue : person.details?.bic
		if (!validateBic(bic)) {
			newErrors.bic = t('BicIsInvalid', 'BIC on virheellinen')
		} else {
			delete newErrors.bic
		}
	}

	if ((checkSingle && 'email' === e.target.id) || !checkSingle) {
		const email = checkSingle ? fieldValue : person.otherDetails?.email
		if (!validateEmail(email)) {
			newErrors.email = t('EmailIsInvalid', 'Sähköpostiosoite on virheellinen')
		} else {
			delete newErrors.email
		}
	}

	if ((checkSingle && 'email2' === e.target.id) || !checkSingle) {
		const email2 = checkSingle ? fieldValue : person.otherDetails?.email2
		if (!validateEmail(email2)) {
			newErrors.email2 = t('EmailIsInvalid', 'Sähköpostiosoite on virheellinen')
		} else {
			delete newErrors.email2
		}
	}

	return newErrors
}
